<template>
  <div v-if="isPriceDifferenceHighlighted" class="price-difference-message">
    {{ priceDifferenceMessage }}
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import CurrencyHelper from '@/helpers/currencyHelper'
import constants from '@/utils/constants'

export default {
  props: {
    vwpfsLeaseData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      leaseTypes: constants.leaseTypes,
    }
  },
  computed: {
    ...mapGetters({
      configuration: 'configuration/configuration',
      configurationExtended: 'configurationExtended/configurationExtended',
      controlCodes: 'quote/controlCodes',
      totalPrice: 'quote/totalPrice',
    }),

    ...mapState('user', ['dealerSettings']),

    vwpfsPrices() {
      const pricingData = this.vwpfsLeaseData?.response?.pricingData
      if (!pricingData || !pricingData.calculatedVehicle) {
        return null
      }
      const vehicle = pricingData?.calculatedVehicle

      return {
        vehicle: {
          netCatalogPrice: CurrencyHelper.fromString(vehicle?.netCatalogPrice),
          optionsAmountExclVat: CurrencyHelper.fromString(vehicle?.optionsAmountExclVat),
          bpmAmount: CurrencyHelper.fromString(vehicle?.bpmAmount),
          nonConfigurableOptionsAmountExclVat: CurrencyHelper.fromString(
            vehicle?.nonConfigurableOptionsAmountExclVat
          ),
        },
      }
    },
    vwpfsTotalPrices() {
      const vehicle =
        this.vwpfsPrices?.vehicle?.netCatalogPrice +
        this.vwpfsPrices?.vehicle?.optionsAmountExclVat +
        this.vwpfsPrices?.vehicle?.bpmAmount +
        this.vwpfsPrices?.vehicle?.nonConfigurableOptionsAmountExclVat
      return {
        vehicle: vehicle,
      }
    },
    cstPrices() {
      const configuration = this.configuration ? this.configuration : this.configurationExtended
      if (!configuration) {
        return null
      }

      return {
        netCatalogPrice: CurrencyHelper.fromString(configuration.NetCatalogPrice.Excl),
        controlCodes: this.controlCodes?.reduce(
          (acc, item) => acc + CurrencyHelper.fromString(item.Price?.Excl),
          0
        ),
        optionsAmountExclVat: CurrencyHelper.fromString(configuration.OptionsTotalPrice.Excl),
        bpmAmount: CurrencyHelper.fromString(configuration.Bpm.Value),
      }
    },
    cstTotalPrices() {
      if (!this.cstPrices) {
        return {}
      }

      const vehicle =
        this.cstPrices.netCatalogPrice +
        this.cstPrices.controlCodes +
        this.cstPrices.optionsAmountExclVat +
        this.cstPrices.bpmAmount
      return {
        vehicle: vehicle,
      }
    },
    minDifferenceHighlight() {
      return this.dealerSettings.vwpfsPlPriceDifferenceLimit || 50
    },
    priceDifference() {
      if (!this.vwpfsTotalPrices.vehicle || !this.cstTotalPrices?.vehicle) return 0

      return this.vwpfsTotalPrices.vehicle - this.cstTotalPrices.vehicle
    },
    isPriceDifferenceHighlighted() {
      if (!this.minDifferenceHighlight) return false

      return Math.abs(this.priceDifference) >= this.minDifferenceHighlight
    },
    priceDifferenceMessage() {
      return this.retrieveOverviewText('priceDifferenceIsHigh', {
        price: CurrencyHelper.currencyRounded(this.minDifferenceHighlight),
      })
    },
  },
  methods: {
    retrieveOverviewText(labelName, params = null) {
      return this.i18n.t(`/financialservices/lease/modal/overview/${labelName}`, params)
    },
  },
}
</script>

<style lang="scss" scoped>
.price-difference-message {
  color: $color-danger;
  font-size: 0.8em;
}
</style>
